import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import ArticlePage from "../pages/article/page";
import GenericArticle from "../pages/article-generic/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/what-is-acbuyspreadsheet",
    element: <ArticlePage />,
  },
  {
    path: "/how-acbuyspreadsheet-improves-workflow",
    element: <GenericArticle />,
  },
  {
    path: "/acbuyspreadsheet-vs-traditional-methods",
    element: <GenericArticle />,
  },
  {
    path: "/top-acbuyspreadsheet-tools-2026",
    element: <GenericArticle />,
  },
  {
    path: "/is-acbuyspreadsheet-worth-it-2026",
    element: <GenericArticle />,
  },
  {
    path: "/acbuyspreadsheet-tutorial-beginners",
    element: <GenericArticle />,
  },
  {
    path: "/acbuyspreadsheet-safety-security",
    element: <GenericArticle />,
  },
  {
    path: "/best-acbuyspreadsheet-templates",
    element: <GenericArticle />,
  },
  {
    path: "/acbuyspreadsheet-pricing-guide",
    element: <GenericArticle />,
  },
  {
    path: "/acbuyspreadsheet-for-dropshipping",
    element: <GenericArticle />,
  },
  {
    path: "/acbuyspreadsheet-mobile-guide",
    element: <GenericArticle />,
  },
  {
    path: "/acbuyspreadsheet-common-mistakes",
    element: <GenericArticle />,
  },
  {
    path: "/acbuyspreadsheet-success-stories",
    element: <GenericArticle />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;